import React, { useEffect } from "react";

import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import store from "./store";
import history from "./history";
import Layouts from "./layouts";
import { API_BASE_URL, THEME_CONFIG, NOTIAPPID } from "./configs/AppConfig";
import "./lang";
import { AuthProvider } from "./context/AuthContext";
import "assets/css/customhrms.css";
import "assets/css/responsive.css";
import apiRequest from "services/ApiProvider";
import MainLayout from "./layouts/MainLayout";
import { Suspense } from "react";




const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
  // const loadOneSignal = () => {
  //   const script = document.createElement("script");
  //   script.src = "https://cdn.onesignal.com/sdks/OneSignalSDK.js";
  //   script.async = true;
  //   document.head.appendChild(script);
  // };

  // useEffect(() => {
  //   loadOneSignal();

  //   const interval = setInterval(() => {
  //     if (window.OneSignal) {
  //       clearInterval(interval);

  //       window.OneSignal = window.OneSignal || [];
  //       window.OneSignal.push(() => {
  //         window.OneSignal.init({
  //           appId: NOTIAPPID,
  //           notifyButton: { enable: true },
  //           autoResubscribe:true,
  //         });

  //         window.OneSignal.getUserId().then(async (playerId) => {
  //           apiRequest.consoleProvider("playerId", playerId);

  //           if (playerId) {
  //             const response = await apiRequest.postPlayer(API_BASE_URL + "/auth/updatePlayerId", { playerId: playerId }, "");
  //             apiRequest.consoleProvider("response p", response);
  //           }
  //         });
  //       });
  //     }
  //   }, 100);
  // }, []);

  return (
    <div className="App">
      <AuthProvider>
        <Provider store={store}>
          <BrowserRouter history={history}>
            <ThemeSwitcherProvider themeMap={themes} defaultTheme={THEME_CONFIG.currentTheme} insertionPoint="styles-insertion-point">
              <Layouts />
            </ThemeSwitcherProvider>
          </BrowserRouter>
        </Provider>
      </AuthProvider>

    
    </div>
  );
}

export default App;
